import { AccountOrProfile } from '../MyLom/Account/EditAccount/Types';
import { Wishlist, WishlistPayload } from '../MyLom/Account/Wishlist/Types';

export function readWishlist(
    accountOrProfile: AccountOrProfile,
    onSuccess: (newWishlist: Wishlist) => void,
    onError: (json: any) => void,
    onFailure?: (error: any) => void,
) {
    fetch('/api/account/' + accountOrProfile.id + '/wishlist', {
        method: 'get',
    })
        .then((response) => response.json())
        .then((json) => {
            if (json.errors) {
                onError(json.errors);
            } else {
                onSuccess(json.data);
            }
        })
        .catch((error) => {
            console.error('Server failure while fetching wishlist: ', error);
            if (onFailure && typeof onFailure === 'function') {
                onFailure(error);
            }
        });
}

export function removeFromWishlist(
    accountOrProfile: AccountOrProfile,
    payload: WishlistPayload,
    onSuccess: (newWishlist: Wishlist) => void,
    onError?: (json: any) => void,
    onFailure?: (error: any) => void,
) {
    fetch('/api/account/' + accountOrProfile.id + '/wishlist/remove', {
        method: 'put',
        body: JSON.stringify(payload),
    })
        .then((response) => response.json())
        .then((json) => {
            if (json.errors && onError && typeof onError === 'function') {
                onError(json.errors);
            } else {
                onSuccess(json.data);
            }
        })
        .catch((error) => {
            console.error('Server failure while removing item from wishlist: ', error);
            if (onFailure && typeof onFailure === 'function') {
                onFailure(error);
            }
        });
}

export function addToWishlist(
    accountOrProfile: AccountOrProfile,
    payload: WishlistPayload,
    onSuccess: (newWishlist: Wishlist) => void,
    onError?: (json: any) => void,
    onFailure?: (error: any) => void,
) {
    fetch('/api/account/' + accountOrProfile.id + '/wishlist/add', {
        method: 'put',
        body: JSON.stringify(payload),
    })
        .then((response) => response.json())
        .then((json) => {
            if (json.errors && onError && typeof onError === 'function') {
                onError(json.errors);
            } else {
                onSuccess(json.data);
            }
        })
        .catch((error) => {
            console.error('Server failure while adding item from wishlist: ', error);
            if (onFailure && typeof onFailure === 'function') {
                onFailure(error);
            }
        });
}

export function readPublicWishlist(
    shortUri: string,
    onSuccess: (newWishlist: Wishlist) => void,
    onError: (json: any) => void,
    onFailure?: (error: any) => void,
) {
    fetch('/api/public/wishlist/' + shortUri, {
        method: 'get',
    })
        .then((response) => response.json())
        .then((json) => {
            if (json.errors) {
                onError(json.errors);
            } else {
                onSuccess(json.data);
            }
        })
        .catch((error) => {
            console.error('Server failure while fetching public wishlist: ', error);
            if (onFailure && typeof onFailure === 'function') {
                onFailure(error);
            }
        });
}
